<template>
  <div class="box10">
    <pageTitle title="真实学员评价" />
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="rgba(75, 132, 250, 0.16)"
      blockColor="#4b84fa"
    />
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    pageTitle,
    studentEvaluation,
    previewImage,
  },

  data() {
    return {
      clickedIndex: 0,
      isPreview: false,
      cur: 0,
      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/java/box10/1.png"),
              id: 1,
            },
            {
              img: require("../../../assets/coursePage/java/box10/2.png"),
              id: 2,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/java/box10/3.png"),
              id: 3,
            },
            {
              img: require("../../../assets/coursePage/java/box10/4.png"),
              id: 4,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/java/box10/5.png"),
              id: 5,
            },
            {
              img: require("../../../assets/coursePage/java/box10/6.png"),
              id: 6,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/java/box10/7.png"),
              id: 7,
            },
            {
              img: require("../../../assets/coursePage/java/box10/8.png"),
              id: 8,
            },
          ],
        },
      ],

      titleColor: "#3E4F48",

      styleData: {
        imgBorder: "border: 0.08rem solid #bedaff;",
        imgHoverBorder: "border: 0.08rem solid #4080ff;",
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      this.isPreview = true;
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
      // this.imageUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box10 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/java/box10/bgc.png") no-repeat;
  background-size: cover;
}
</style>
